<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useFVStore } from "@/stores/formvibes";
import { storeToRefs } from "pinia";
import { CircleCloseFilled, InfoFilled, Refresh } from "@element-plus/icons-vue";

const props = defineProps([ 'close', 'isVisible' ]);

const store = useFVStore();
const showDialog = ref(props.isVisible);

const {selectedRowsId, isSaving} = storeToRefs(store);

const status = ref(window.fvGlobalVar.entry_status);

const selectedStatus = ref('read');
watch([() => props.isVisible],() => {
    if(props.isVisible){
        showDialog.value = true;
    }
})

const isData = computed(() => {
    return selectedRowsId.value.length ? true : false;
});

const updateStatus = async () => {
    await store.updateStatus(selectedStatus.value,'','bulk');
    closeDialog();
}
const closeDialog = () => {
    showDialog.value = false;
    props.close();
}
</script>

<template>
    <div>
        <el-dialog 
        v-model="showDialog" 
        :with-header="true"
        :show-close="true"
        @close="closeDialog"
        align-center="true"
        class="fv-sub-bulk-staus-dialog"
        width="600px"
        >
            <template #header="{ close, titleId, titleClass }">
                <div class="fv-header-title">
                    <el-icon size="20">
                        <InfoFilled />
                    </el-icon>
                    <strong>Change Status</strong>
                </div>
            </template>
            <div v-loading="isSaving">
            <div v-if="!isData">Please select a row to change status</div>
            <div v-if="isData">
                <h3> Select a status</h3>
                <el-select v-model="selectedStatus" placeholder="Select" size="large">
                    <el-option
                    v-for="item in status"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                    />
                </el-select>
            </div>
        </div>
            <template #footer>
                <el-button @click="closeDialog">Cancel</el-button>
                <el-button type="primary" :disabled="!isData" @click="updateStatus">Save</el-button>
            </template>
        </el-dialog>
    </div>
</template>